/**
 * Convert a 24-hour time string ("HH:mm") into a 12-hour label ("h:mm AM/PM").
 * Keeps input unchanged if it can't be parsed.
 */
export function formatTime12h(time24: string): string {
  const [hRaw, mRaw] = time24.split(":");
  const h = Number(hRaw);
  const m = Number(mRaw);

  if (!Number.isFinite(h) || !Number.isFinite(m)) return time24;

  const suffix = h >= 12 ? "PM" : "AM";
  const hour12 = ((h + 11) % 12) + 1;
  return `${hour12}:${String(m).padStart(2, "0")} ${suffix}`;
}

